

















import mixins from 'vue-typed-mixins';
import { LongTextOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => LongTextOptions,
    },
  },
  mounted() {
    // set  values to defaults
    this.$emit('input', {
      rows: 5,
      ...this.value,
    });
  },
});
